var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLaptop = function SvgLaptop(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.77 23.97H3.17a.2.2 0 0 1-.2-.2V4.17c0-.11.09-.2.2-.2h25.6c.11 0 .2.09.2.2v19.6a.2.2 0 0 1-.2.2m-23.6-2h21.6a.2.2 0 0 0 .2-.2V6.17a.2.2 0 0 0-.2-.2H5.17a.2.2 0 0 0-.2.2v15.6c0 .11.09.2.2.2m26.6 7H.17a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h31.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2"
  })));
};
export default SvgLaptop;